module.exports = __webpack_public_path__ + "static/media/after-service-qr.24cf216e.jpg";